import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';

@Component({
  standalone: true,
  selector: 'app-link-btn',
  templateUrl: './link-btn.component.html',
  styleUrls: ['./link-btn.component.scss'],
  imports: [CommonModule, CeIconComponent],
})
export class LinkBtnComponent {
  @Output() custom_click = new EventEmitter<string>();
  constructor() {}

  @Input()
  label = '';

  @Input()
  color = 'primary-100';

  @Input()
  type = 'button';

  @Input()
  active = true;

  @Input() alert = false;

  @Input()
  size: 'medium' | 'large' = 'medium';

  @Input()
  IconType: any = 'add';

  @Input()
  iconSize: any = '16';

  @Input()
  disabled: boolean = false;

  @Input()
  loading: boolean = false;
}
